import React from 'react';
import { Box, Typography, Switch, Button, TextField } from '@mui/material';

const CONTROL_ROW_SX = {
  flex: 1,
  minHeight: 0,
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  px: 1,
};

function GeneralControlWidget({ widget, data, theme, isEditMode }) {
  const isDark = theme === 'dark';
  const liveData = Array.isArray(data) ? data : [];
  const tagprop = widget?.props?.extended?.tagprops?.[0];
  const match = tagprop && liveData.find((d) => String(d.TagId) === String(tagprop.tagId));
  const value = match?.value;
  const label = tagprop?.alias || tagprop?.tagId || '—';

  if (widget.type === 'Switch') {
    return (
      <Box sx={CONTROL_ROW_SX}>
        <Typography variant="body2" sx={{ color: isDark ? '#ccc' : '#333', pr: 1 }}>{label}</Typography>
        <Switch checked={value === '1' || value === 1} disabled={isEditMode} size="small" />
      </Box>
    );
  }

  if (widget.type === 'Status') {
    const isOn = value === '1' || value === 1;
    return (
      <Box sx={CONTROL_ROW_SX}>
        <Typography variant="body2" sx={{ color: isDark ? '#ccc' : '#333', pr: 1 }}>{label}</Typography>
        <Box sx={{ px: 1.5, py: 0.3, borderRadius: 5, backgroundColor: isOn ? 'green' : 'red', color: '#fff', fontWeight: 700, fontSize: 11, flexShrink: 0 }}>
          {isOn ? 'ON' : 'OFF'}
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', justifyContent: 'center', px: 1, gap: 0.5 }}>
      <Typography variant="caption" sx={{ color: isDark ? '#aaa' : '#666' }}>{label}</Typography>
      <Box sx={{ display: 'flex', gap: 1, alignItems: 'stretch' }}>
        <TextField size="small" defaultValue={value ?? ''} variant="outlined" sx={{ flex: 1, minWidth: 0 }} disabled={isEditMode} />
        <Button size="small" variant="contained" disabled={isEditMode} sx={{ flexShrink: 0 }}>Set</Button>
      </Box>
    </Box>
  );
}

export default React.memo(GeneralControlWidget);
